import { of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/processing-order-sdk";
import * as i2 from "@legalzoom/business-formation-sdk";
export class ProcessingOrderService {
    constructor(sdkProcessingOrderService, trackJsErrorLogService) {
        this.sdkProcessingOrderService = sdkProcessingOrderService;
        this.trackJsErrorLogService = trackJsErrorLogService;
    }
    prepareGetProcessingOrderById(context, appService, processingOrderId, authToken, customerId, productName) {
        const that = this;
        return {
            name: 'prepareGetProcessingOrderById processing-order.service' + context.constructor.name,
            pre: () => {
                return that.sdkProcessingOrderService.getProcessingOrdersById(processingOrderId, customerId);
            },
            post: (response) => {
                const appState = appService.app;
                if (response && response.processingOrder) {
                    appState.processingOrderId = response.processingOrder.processingOrderId;
                    appState.isQuestionnaireComplete = response.processingOrder.isQuestionnaireCompleted;
                }
                else {
                    appState.processingOrderId = 0;
                }
                appService.app = appState;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJsErrorLogService.track(productName, 'processing-order.service' + context.constructor.name, error);
                return of(null);
            }
        };
    }
}
ProcessingOrderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProcessingOrderService_Factory() { return new ProcessingOrderService(i0.ɵɵinject(i1.ProcessingOrderService), i0.ɵɵinject(i2.TrackJsErrorLogService)); }, token: ProcessingOrderService, providedIn: "root" });
